import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateButton from '../buttons/CreateButton';
import ProductCreateTab from './ProductCreateTab';
import withPrivileges from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import { productPropertiesType } from '../../types';

CreateProductRow.propTypes = {
    productProps: productPropertiesType.isRequired,
};

function CreateProductRow(props) {
    const { productProps } = props;
    const { t } = useTranslation();
    const [isCreateVisible, setCreateVisible] = useState(false);
    const actionHandler = () => setCreateVisible(!isCreateVisible);
    return (
        <div className="create-product-row">
            <CreateButton onAction={actionHandler} isCreateVisible={isCreateVisible}><FontAwesomeIcon icon="plus" />&nbsp;{t('products.create-product')}</CreateButton>
            {isCreateVisible && <ProductCreateTab productProps={productProps} hideHandler={() => setCreateVisible(false)} />}
        </div>
    );
}

export default withPrivileges([Privileges.PRODUCT_EDIT])(CreateProductRow);
